import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("App crash capturado:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div data-testid="error-boundary" className="min-h-screen flex items-center justify-center bg-background p-6">
          <div className="max-w-sm w-full rounded-2xl border border-border bg-card p-6 text-center">
            <h2 className="font-display text-xl font-black text-foreground mb-2">Ops! Algo travou.</h2>
            <p className="text-muted-foreground text-sm mb-5">Não se preocupe, seus dados estão salvos. Toque abaixo para recarregar.</p>
            <button
              data-testid="error-reload-btn"
              onClick={() => { window.location.href = "/painel"; }}
              className="w-full rounded-full bg-primary text-primary-foreground font-semibold py-3"
            >
              Voltar ao painel
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
